import { FC } from "react";
import Loader from "@shared/components/loader";

const PageLoader: FC = () => <Loader fullscreen />;

export default PageLoader;
